module.exports = __webpack_public_path__ + "static/media/defame-potion.16069de0.png";